import { render, staticRenderFns } from "./FormPhieuMuon.vue?vue&type=template&id=5edaf295&scoped=true"
import script from "./FormPhieuMuon.vue?vue&type=script&lang=js"
export * from "./FormPhieuMuon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5edaf295",
  null
  
)

export default component.exports